// One login per person: an admin who is also an employee of the company has
// their own workspace under /employee (leave, payslips, attendance, reviews…),
// shown alongside the admin sections they have access to.
//
// Requests made from those pages carry WORKSPACE_HEADER so the API serves them
// as the employee login — e.g. "my leave requests", not the company's. The app
// shell (session, permissions, subscription) always speaks for the admin
// login, so those calls pass `{ workspace: "admin" }` in their axios config.

export const WORKSPACE_HEADER = "x-zenith-workspace";

export const isLinkedAdmin = (user) =>
  user?.role === "admin" && Boolean(user?.employee_id);

export const isEmployeeWorkspacePath = (pathname = "") =>
  pathname === "/employee" || pathname.startsWith("/employee/");

let linkedAdminSession = false;

// Kept in step with the signed-in user by AuthProvider.
export const setWorkspaceUser = (user) => {
  linkedAdminSession = isLinkedAdmin(user);
};

// "My team" pages: /team/... in the admin layout, /employee/team/... in the
// employee portal. Their list requests carry TEAM_VIEW_HEADER so the API
// returns the caller's direct reports instead of everything they administer.
export const TEAM_VIEW_HEADER = "x-zenith-view";

export const isTeamPath = (pathname = "") =>
  /^\/(employee\/)?team(\/|$)/.test(pathname);

export const shouldTagTeamView = (config) =>
  config?.workspace !== "admin" && isTeamPath(window.location.pathname);

export const shouldTagEmployeeWorkspace = (config) =>
  linkedAdminSession &&
  config?.workspace !== "admin" &&
  isEmployeeWorkspacePath(window.location.pathname);

// Where a login lands. On the phone app a linked admin starts in their own
// workspace (attendance, leave); on the web, in the admin area.
export const homePathFor = (user, { native = false } = {}) => {
  if (user?.role === "super_admin") return "/super-admin/dashboard";
  if (user?.role === "admin") {
    return native && isLinkedAdmin(user) ? "/employee/dashboard" : "/dashboard";
  }
  return "/employee/dashboard";
};
